(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('UserAddController', UserAddController);

    UserAddController.$inject = ['$scope', '$filter', '$uibModalInstance', 'UserService', 'userId'];

    function UserAddController($scope, $filter, $uibModalInstance, UserService, userId) {
        var vm = this;
        vm.requestRunning = false;

        var isEdit = !!userId;
        vm.isEdit = isEdit;

        vm.groups = [];
        vm.dataUser = {
            username: '',
            email: '',
            group: {},
            password: '',
            confirmPassword: ''
        };

        vm.modalTitle = isEdit ? 'editUser' : 'addUser';
        vm.labelButton = isEdit ? 'save' : 'add';

        if (isEdit) {
            vm.requestRunning = true;
            UserService.getUser(userId).then(successUser).catch(errorUser);
        } else {
            getGroups();
        }

        vm.checkPassword = function () {
            return vm.dataUser.password == vm.dataUser.confirmPassword;
        }

        vm.close = function () {
            if (!vm.requestRunning) {
                $scope.$emit('userEditCancel');
                $uibModalInstance.dismiss('cancel');
            }
        }

        vm.save = function () {
            if (vm.formUserAdd.$valid && !vm.requestRunning) {
                vm.requestRunning = true;
                var data = {
                    username: vm.dataUser.username,
                    email: vm.dataUser.email,
                    groupId: vm.dataUser.group.id,
                    groupName: vm.dataUser.group.name,
                    password: vm.dataUser.password,
                    confirmPassword: vm.dataUser.confirmPassword
                };
                if (isEdit) {
                    data.id = vm.dataUser.id;
                    UserService.updateUser(data).then(successUpdate).catch(errorSave);
                } else {
                    UserService.addUser(data).then(successAdd).catch(errorSave);
                }
            }
        }

        function getGroups() {
            return UserService.getGroups().then(successGroups).catch(errorUser);
        }

        function successGroups(data) {
            vm.groups = data;
            if (!isEdit) {
                vm.dataUser.group = {
                    id: data[0].id.toString(),
                    name: data[0].name
                };
            }
        }

        function successUser(data) {
            vm.requestRunning = false;
            vm.dataUser = {
                id: data.id,
                username: data.username,
                email: data.email,
                password: data.password,
                group: {name: data.groupName},
                confirmPassword: data.confirmPassword
            };
            getGroups().then(function () {
                vm.dataUser.group = $filter('filter')(vm.groups, {id: data.groupId}, true)[0];
            });
        }

        function errorUser(response) {
            vm.requestRunning = false;
            UserService.errorModalConstructor(response, 'get');
            vm.close();
        }

        function successAdd(data) {
            vm.requestRunning = false;
            UserService.successModalConstructor('save');
            $scope.$emit('userAddSuccess', data);
        }

        function successUpdate(data) {
            vm.requestRunning = false;
            $scope.$emit('userUpdateSuccess', data);
        }

        function errorSave(response) {
            vm.requestRunning = false;
            UserService.errorModalConstructor(response, isEdit ? 'edit' : 'add');
        }

    }
})();
